<template>
  <div class="font-semibold text-green-600 bg-green-200 rounded-lg px-6 py-4">
    <slot />
  </div>
</template>
